import { InputBase, styled } from '@mui/material'
import { CellPropsBase, CellTitle, CellValueArea, FormCell } from '.'
import { ChangeEvent, useCallback, useEffect, useState } from 'react'
import { useDebounce } from '../../../../hooks/useDebounce'
import { colorPalette } from '../../../../style/colorPalette'

type TextCellProps = {
  value: string | undefined
  onChange?: (v: string | undefined) => void
  onBlur?: () => void
  onCompositionStart?: () => void
  onCompositionEnd?: () => void
} & CellPropsBase
export const TextCell = ({
  label,
  cellWidth,
  value,
  onChange,
  onCompositionStart,
  onCompositionEnd,
  editable = true,
  required = false,
  edited,
  validationErrors,
}: TextCellProps) => {
  const [inputValue, setInputValue] = useState<string | undefined>(value)
  const [changedByInput, setChangedByInput] = useState<boolean>(false)
  useEffect(() => {
    setInputValue(value)
    setChangedByInput(false)
  }, [value])
  const debouncedValue = useDebounce(inputValue, 300)
  useEffect(() => {
    if (changedByInput) {
      onChange && onChange(debouncedValue)
    }
  }, [changedByInput, debouncedValue, onChange])
  const onChangeInput = useCallback((e: ChangeEvent<HTMLInputElement>) => {
    setInputValue(e.target.value)
    setChangedByInput(true)
  }, [])

  return (
    <FormCell cellWidth={cellWidth}>
      <CellTitle title={label} required={required} />
      <CellValueArea edited={edited} validationErros={validationErrors}>
        <TextInput
          value={inputValue}
          onChange={onChangeInput}
          disabled={!editable}
          onCompositionStart={onCompositionStart}
          onCompositionEnd={onCompositionEnd}
        />
      </CellValueArea>
    </FormCell>
  )
}

const TextInput = styled(InputBase)({
  width: '100%',
  '& .MuiInputBase-input.Mui-disabled': {
    color: colorPalette.monotone[3],
    '-webkit-text-fill-color': colorPalette.monotone[3],
  },
})
